import { ADD_NEWS, UPDATE_NOTIFICATIONS } from './NewsActions';

// Initial State
const initialState = {
  news: {
    status: null,
    errors: null,
    items: [],
  },
  count: 0,
};

const NewsReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_NEWS: {
      return { ...state, news: { items: action.news, status: action.status, errors: action.errors } };
    }
    case UPDATE_NOTIFICATIONS: {
      return { ...state, count: action.count || 0 };
    }
    default:
      return state;
  }
};

/* Selectors */
export const getNews = state => state.news.news.items;
export const getLoading = state => state.news.news.status === 'loading';
export const getLoaded = state => state.news.news.status === 'loaded';
export const getHasErrors = state => state.news.news.status === 'error';
export const getErrors = state => (state.news.news.status === 'error' ? state.news.news.errors : null);
export const getCount = state => state.news.count;

// Export Reducer
export default NewsReducer;
